import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

export const DIALOG_COUPON_EXCEPTION = 'DIALOG_COUPON_EXCEPTION'

export interface DialogCouponExceptionProps {
  onConfirm: () => void
  message: string
}

export const DialogCouponException = () => {
  const { open, onConfirm, message } = useDialog<DialogCouponExceptionProps>(DIALOG_COUPON_EXCEPTION)
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })
  return (
    <Dialog open={open} maxWidth={320}>
      <DialogHeader align="center" title={t('cartUi.checkoutFailed', { defaultValue: '結帳失敗' })} />
      <DialogContent>
        <Text>{message}</Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} width="100%">
          {t('cartUi.goToCart', { defaultValue: '前往購物車' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
